var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"processing-dots",attrs:{"uk-tooltip":_vm.tooltipText}},[_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }